import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CardComponent } from '../card/card/card.component';
import { CardContentComponent } from '../card/card-content/card-content.component';

@Component({
  selector: 'nk-layout-centered',
  templateUrl: './layout-centered.component.html',
  imports: [CardComponent, CardContentComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutCenteredComponent {
  public columnClasses = input('col-lg-5 col-md-7 col-sm-8 col-xs-12');
  public andClass = input('');
}
